// src/information-card/constants.js

export const FORM_SECTIONS = [
    {
        title: "Thông tin mặt trước",
        fields: [
            {
                key: "full_name",
                label: "Họ và tên",
                type: "text",
                col: "col-12",
                rules: "required",
                placeholder: "Nhập họ và tên",
            },
            {
                key: "id_number",
                label: "Số CCCD",
                type: "text",
                col: "col-md-6",
                rules: "required|digits:12",
                placeholder: "Số căn cước (12 chữ số)",
                maxlength: 12,
            },
            {
                key: "date_of_birth",
                label: "Ngày sinh",
                type: "date",
                col: "col-md-6",
                rules: "required",
                placeholder: "Ngày sinh",
            },
            {
                key: "gender",
                label: "Giới tính",
                type: "select",
                col: "col-md-6",
                rules: "required",
                options: [
                    { label: "Nam", value: "Nam" },
                    { label: "Nữ", value: "Nữ" },
                ],
            },
            {
                key: "nationality",
                label: "Quốc tịch",
                type: "text",
                col: "col-md-6",
                rules: "required",
                placeholder: "Quốc tịch",
            },
            {
                key: "place_of_birth",
                label: "Quê quán",
                type: "textarea",
                col: "col-12",
                rules: "required",
                placeholder: "Quê quán",
            },
            {
                key: "place_of_residence",
                label: "Nơi thường trú",
                type: "textarea",
                col: "col-12",
                rules: "required",
                placeholder: "Địa chỉ thường trú",
            },
            {
                key: "expiry_date",
                label: "Có giá trị đến",
                type: "date",
                col: "col-md-12",
                rules: "required",
                placeholder: "Giá trị đến",
            },
        ],
    },
    {
        title: "Thông tin mặt sau",
        fields: [
            {
                key: "issued_date",
                label: "Ngày cấp",
                type: "date",
                col: "col-12",
                rules: "required",
                placeholder: "Ngày cấp",
            },
            {
                key: "issued_place",
                label: "Cơ quan cấp",
                type: "text",
                col: "col-12",
                rules: "required",
                placeholder: "Cơ quan cấp căn cước",
            },
        ],
    },
];

